import { femaleBodyDensityConsts, maleBodyDensityConsts } from './constants';

function formatValueToCalc(value: string | number): number {
  if (typeof value === 'string') {
    const formattedValue = (value as string).replaceAll(',', '.');
    const floatValue = parseFloat(formattedValue);
    return floatValue;
  }

  return value as number;
}

export const calculateTotal = (data?: any) => {
  const {
    abdomen,
    middle_armpit,
    biceps,
    breastplate,
    calf,
    subscapular,
    heigsupra_iliacaht,
    thigh,
    triceps,
    genre,
    studentAge,
  } = data;

  if (!studentAge) {
    return undefined;
  }

  const skinFoldsTotalValue = [
    formatValueToCalc(abdomen),
    formatValueToCalc(middle_armpit),
    formatValueToCalc(biceps),
    formatValueToCalc(breastplate),
    formatValueToCalc(calf),
    formatValueToCalc(subscapular),
    formatValueToCalc(heigsupra_iliacaht),
    formatValueToCalc(thigh),
    formatValueToCalc(triceps),
  ];

  const skinFoldsTotalValuesSummed = skinFoldsTotalValue.reduce(
    (acc, current) => acc + current,
  );

  const bodyDensityConstants =
    genre === 'female' ? femaleBodyDensityConsts : maleBodyDensityConsts;

  const firstPart =
    bodyDensityConstants.const1 -
    bodyDensityConstants.const2 * skinFoldsTotalValuesSummed;

  const secondPart =
    bodyDensityConstants.const3 * skinFoldsTotalValuesSummed ** 2;

  const thirdPart = bodyDensityConstants.const4 * studentAge;

  const bodyDensity = firstPart + secondPart - thirdPart;

  const bodyFatPercentage =
    (bodyDensityConstants.const5 / bodyDensity - bodyDensityConstants.const6) *
    100;

  return !skinFoldsTotalValue.includes(0) ? bodyFatPercentage.toFixed(2) : 0;
};
